export const CURRENT_SEASON = "20262027";

export type Sport = { sid: number; name: string };

export type Team = {
  sid: number;
  tid: number;
  name: string;
  sport?: string;
  season?: string;
};

export type FixtureState = "scheduled" | "cancelled" | "postponed";

export type Fixture = {
  fid: number;
  date: string;
  time: string | null;
  meetTime: string | null;
  venue: string | null;
  opponent: string;
  result: string | null;
  transportNotes: string | null;
  fixtureState: FixtureState;
  detailsPath: string;
};

export type TeamSheetPlayer = {
  name: string;
  annotations: string[];
};

export type TeamSheetResult =
  | { status: "not_published"; players: [] }
  | { status: "password_required"; players: [] }
  | { status: "incorrect_password"; players: [] }
  | { status: "published"; players: TeamSheetPlayer[] };

export type ApiErrorCode =
  | "invalid_request"
  | "upstream_unavailable"
  | "cookie_challenge_changed"
  | "parsing_failed"
  | "incorrect_password"
  | "sheet_not_published";

export type ApiError = { error: { code: ApiErrorCode; message: string } };

export type SelectionStatus =
  | "confirmed"
  | "awaiting_team_sheet"
  | "not_selected"
  | "possible"
  | "unable_to_check";

export type AssociationConfidence = "candidate" | "known";

export type Pupil = { id: string; displayName: string };

export type Association = {
  id: string;
  pupilId: string;
  teamId: string;
  confidence: AssociationConfidence;
  firstSeenAt: string;
  lastConfirmedAt: string | null;
  appearanceCount: number;
};

export type StoredTeam = Team & { id: string; sport: string; season: string };

export type StoredFixture = Fixture & {
  id: string;
  teamId: string;
  checkedAt: string;
  checkError: ApiErrorCode | null;
  teamSheet: Array<TeamSheetPlayer | string> | null;
};

export type Selection = {
  id: string;
  fixtureId: string;
  pupilId: string;
  selected: boolean;
  checkedAt: string;
};

export type RefreshRun = {
  id: string;
  startedAt: string;
  completedAt: string;
  outcome: "success" | "partial" | "failed";
  errorCategory: ApiErrorCode | null;
};
